import React, { createContext, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [isDate, setDate] = useState(true);


  return (
    <AppContext.Provider
      value={{
        setDate,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
